import mainImage from "../../images/apps/sa/main.png";
import step1 from "../../images/apps/wb/instructions/step-1.png";
import step2 from "../../images/apps/wb/instructions/step-2.png";
import step3_1 from "../../images/apps/wb/instructions/step-3-1.png";
import step3_2 from "../../images/apps/wb/instructions/step-3-2.png";
import step4 from "../../images/apps/wb/instructions/step-4.png";
import step5 from "../../images/apps/wb/instructions/step-5.png";
import step6 from "../../images/apps/wb/instructions/step-6.png";

const wbData = {
  name: "Workflow Blocks Plus",
  introText:
    "Introducing the ultimate app for all your power workflow needs. This app has collection of advanced workflow blocks for subitems, dependency columns, formula columns and much more...",
  subtext: "Ultimate workflow blocks to supercharge your workflows",
  image: mainImage,
  clientId: "5f0b77f5ccf7a36dc98e06ed92affa5f",
  promoVideoId: "N-KQWJbGM_U",
  demoVideoId: "N-KQWJbGM_U",
  features: [],
  instructions: [
    {
      text: "This app works in workflow builder, so first step is to create a new workflow.",
      images: [step1],
    },
    {
      text: "Now you can add custom trigger block by scrolling and finding the app name in side panel, or by directly searching for it.",
      images: [step2],
    },
    {
      text: "Similarly you can add any action block from the app that you want to use in your workflow, by scrolling in side panel or directly searching for it.",
      images: [step3_1, step3_2],
    },
    {
      text: "Once the required values are set in the blocks, press 'Publish Workflow' and it will start working for you.",
      images: [step4],
    },
    {
      text: "You can also use in-built monday action blocks (or action blocks from other apps) with trigger blocks of this app.",
      images: [step5],
    },
    {
      text: "Similarly you can use action blocks of this app with in-built monday trigger blocks (or trigger blocks from other apps).",
      images: [step6],
    },
  ],
  faqs: [
    {
      question: "What is pricing for this app based on ?",
      answer:
        "The pricing is based on the number of operations performed per month. Each block run can consume multiple operations depending on the complexity of the automation recipe.",
    },
    {
      question: "How many operations are consumed for each block run ?",
      answer:
        "Number of operations consumed by an block run depends on number of items affected by that run. For example, a simple action that copies a column to another column will consume 1 operation per run, whereas an action that deletes 10 items in 1 run will consume 10 operations.",
    },
    {
      question: "The block I need is not available in this app, can you add it ?",
      answer:
        "Yes, we do add new blocks on a regular basis. Please reach out to us at support@superworkday.com if you have any specific worflow block in mind.",
    },
  ],
};

export default wbData;
